<template>
  <div
    :ref="reference"
    :class="classes"
    class="bloc-scrollable"
  >
    <slot />

    <!-- <v-icon -->
    <!--   v-show="scrollbar" -->
    <!--   class="float-icon top" -->
    <!--   large -->
    <!-- > -->
    <!--   mdi-arrow-up-bold -->
    <!-- </v-icon> -->
    <!-- <v-icon -->
    <!--   v-show="scrollbar" -->
    <!--   class="float-icon bottom" -->
    <!--   large -->
    <!-- > -->
    <!--   mdi-arrow-down-bold -->
    <!-- </v-icon> -->
  </div>
</template>

<script>
export default {
  name: 'Scrollable',

  props: {
    reference: { type: String, default: 'scrollable-options' },
    action: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    md: { type: Boolean, default: false },
    sm: { type: Boolean, default: false },
    xs: { type: Boolean, default: false },
    fullScreen: { type: Boolean, default: false }
  },

  data () {
    return {
      offset: 0,
      scroll: 0
    }
  },

  computed: {
    classes () {
      return {
        'bloc-action-full': this.full,
        'bloc-action-md': this.md,
        'bloc-action-sm': this.sm,
        'bloc-action-xs': this.xs,
        'bloc-full-screen': this.fullScreen,
        'bloc-action': this.action,
        'pr-1': this.scrollbar,
        'mr-n1': !this.scrollbar
      }
    },
    scrollbar () {
      return this.scroll > this.offset
    }
  },

  mounted() {
    this.offset = this.$refs[this.reference].offsetHeight
    this.scroll = this.$refs[this.reference].scrollHeight
  },

  updated() {
    this.offset = this.$refs[this.reference].offsetHeight
    this.scroll = this.$refs[this.reference].scrollHeight
  }
}
</script>

<style scoped>
.float-icon {
  position: absolute;
  z-index: 10;
  opacity: 0.5;
}
.float-icon.bottom {
  right: 5px;
  bottom: 70px;
}
.float-icon.top {
  right: 5px;
  top: 90px;
}
</style>
